export default __webpack_public_path__ + "static/media/06-portfolio2.0-Main.0d5abafc.PNG";